import clsx from 'clsx'
import React from 'react'

type Props = {
  label?: string
  isHidden?: boolean
  children?: React.ReactNode
}

import './Group.scss'

export const Group: React.FC<Props> = ({ label, isHidden, children }) => {
  return (
    <div
      className={clsx(
        'program-options-group',
        isHidden && 'program-options-group--hidden',
      )}
    >
      {label && (
        <div className="program-options-group__label type-eyebrow">{label}</div>
      )}
      <div className="program-options-group__content">{children}</div>
    </div>
  )
}
